import ItemsDetailsMobileWrapper from 'components/ItemsDetailsMobileWrapper'
import ItemHeader from 'containers/ManageAccess/ItemHeader'
import { useIsSmallScreen, useQuery } from 'packages/core'
import { Loader } from 'packages/eid-ui'
import {
    useCheckSharedFolderAccessByAssignmentId,
    useSharedFolderManageAccess,
    useTargetPerson,
} from 'hooks'
import SharedFolderDetails from './SharedFolderDetails'
import { ManageAccessDrawer } from 'components/Drawer/ManageAccessDrawer'

const SharedFoldersDrawer = ({ attributes, toggleDrawer, ...rest }) => {
    const isSmallScreen = useIsSmallScreen()
    const headerAttribute = attributes.find((x) => x.isHeader)

    const [targetPerson] = useTargetPerson()

    const query = useQuery()
    const id = query.get('selected')
    const assignmentId = query.get('assignmentId')

    const { data: assignmentStatus } = useCheckSharedFolderAccessByAssignmentId(
        assignmentId,
        targetPerson.id,
    )

    const { data: sharedFolder } = useSharedFolderManageAccess(
        assignmentId ? assignmentId : id,
        assignmentId ? true : false,
        targetPerson?.id,
    )

    let item
    if (sharedFolder && assignmentStatus) {
        item = {
            resource: sharedFolder,
            assignment: assignmentStatus,
        }
    }

    const itemDetails = <SharedFolderDetails item={item} {...rest} />

    return isSmallScreen ? (
        <ItemsDetailsMobileWrapper toggleDrawer={toggleDrawer}>
            <ItemHeader title={item?.resource?.[headerAttribute.name]} />
            {!item && <Loader />}
            {item && itemDetails}
        </ItemsDetailsMobileWrapper>
    ) : (
        <ManageAccessDrawer
            id={id}
            toggleDrawer={toggleDrawer}
            item={item}
            itemDetails={itemDetails}
            headerAttribute={headerAttribute}
        />
    )
}

export default SharedFoldersDrawer
